'use client';

const paymentMethods = [
  { icon: 'fas fa-money-bill-wave', label: 'Espèces', desc: 'Paiement en cash accepté', color: '#0e5932' },
  { icon: 'fas fa-mobile-alt', label: 'Mobile Money', desc: 'Orange Money, MTN MoMo, Wave', color: '#fbaf45' },
  { icon: 'fas fa-credit-card', label: 'Carte Bancaire', desc: 'Visa, Mastercard, CB', color: '#0e5932' },
  { icon: 'fas fa-file-invoice', label: 'Chèque', desc: 'Chèques bancaires acceptés', color: '#fbaf45' },
];

const insurances = [
  { name: 'NSIA Assurances', abbr: 'NSIA', color: '#0e5932' },
  { name: 'Sanlam Assurances', abbr: 'SANLAM', color: '#fbaf45' },
  { name: 'Allianz CI', abbr: 'ALLIANZ', color: '#0e5932' },
  { name: 'AXA Assurances', abbr: 'AXA', color: '#fbaf45' },
  { name: 'Saham Assurance', abbr: 'SAHAM', color: '#0e5932' },
  { name: 'Atlantique Assurances', abbr: 'ATLANTIQUE', color: '#fbaf45' },
  { name: 'CNPS', abbr: 'CNPS', color: '#0e5932' },
  { name: 'Mutuelle Générale', abbr: 'MUTUELLE', color: '#fbaf45' },
];

export default function PaymentInsuranceSection() {
  return (
    <>
      {/* PAYMENT METHODS */}
      <section className="py-20" style={{ backgroundColor: '#f8fdf9' }}>
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col lg:flex-row items-center gap-16">
            {/* Left: Text + Methods */}
            <div className="w-full lg:w-1/2">
              <span className="text-xs font-bold uppercase tracking-widest mb-3 block" style={{ color: '#fbaf45' }}>
                Modes de Règlement
              </span>
              <h2 className="text-3xl md:text-4xl font-black mb-4" style={{ color: '#1d3c5e', fontFamily: 'Lato, sans-serif' }}>
                Paiement Facile & Flexible chez COSA
              </h2>
              <p className="text-gray-500 mb-10 leading-relaxed">
                Pour votre confort, COSA Ananeraie accepte plusieurs modes de paiement. Réglez vos consultations et examens en toute simplicité.
              </p>

              <div className="grid grid-cols-2 gap-5">
                {paymentMethods?.map((pm, i) => (
                  <div
                    key={i}
                    className="flex items-start gap-4 p-5 rounded-xl transition-all hover:shadow-md"
                    style={{ backgroundColor: '#fff', border: `1.5px solid ${pm?.color}20` }}
                  >
                    <div
                      className="w-12 h-12 rounded-xl flex items-center justify-center text-xl flex-shrink-0"
                      style={{ backgroundColor: `${pm?.color}15`, color: pm?.color }}
                    >
                      <i className={pm?.icon}></i>
                    </div>
                    <div>
                      <div className="font-bold text-sm mb-1" style={{ color: '#1d3c5e' }}>{pm?.label}</div>
                      <div className="text-xs text-gray-500">{pm?.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right: Image */}
            <div className="w-full lg:w-1/2">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="/assets/images/payment_methods_cosa.png"
                  alt="Modes de paiement acceptés à COSA Ananeraie : espèces, mobile money, carte bancaire et chèque"
                  className="w-full object-cover"
                  style={{ height: '420px' }}
                />
                <div
                  className="absolute bottom-0 left-0 right-0 p-6"
                  style={{ background: 'linear-gradient(to top, rgba(14,89,50,0.9), transparent)' }}
                >
                  <p className="text-white font-bold text-lg">Paiement sécurisé & confidentiel</p>
                  <p className="text-white text-sm opacity-80">Votre santé, notre priorité — sans contrainte financière</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* INSURANCE PARTNERS */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-14">
            <span className="text-xs font-bold uppercase tracking-widest mb-3 block" style={{ color: '#fbaf45' }}>
              Couverture Santé
            </span>
            <h2 className="text-3xl md:text-4xl font-black mb-4" style={{ color: '#1d3c5e', fontFamily: 'Lato, sans-serif' }}>
              Nos Partenaires Assurances
            </h2>
            <p className="text-gray-500 max-w-2xl mx-auto">
              COSA Ananeraie est conventionné avec les principales compagnies d'assurance santé et mutuelles en Côte d'Ivoire. Votre prise en charge est facilitée.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-5 mb-10">
            {insurances?.map((ins, i) => (
              <div
                key={i}
                className="flex flex-col items-center justify-center p-6 rounded-xl transition-all hover:shadow-lg hover:-translate-y-1 cursor-default"
                style={{ border: `2px solid ${ins?.color}20`, backgroundColor: '#fafafa' }}
              >
                <div
                  className="w-14 h-14 rounded-full flex items-center justify-center text-white font-black text-sm mb-3"
                  style={{ backgroundColor: ins?.color }}
                >
                  {ins?.abbr?.substring(0, 2)}
                </div>
                <span className="text-xs font-bold text-center" style={{ color: '#1d3c5e' }}>{ins?.name}</span>
              </div>
            ))}
          </div>

          <div
            className="rounded-2xl p-8 text-center"
            style={{ backgroundColor: '#0e5932' }}
          >
            <i className="fas fa-shield-alt text-4xl mb-4" style={{ color: '#fbaf45' }}></i>
            <h3 className="text-white font-black text-xl mb-3">Votre assurance n'est pas listée ?</h3>
            <p className="text-white opacity-80 mb-6 max-w-xl mx-auto text-sm">
              Contactez-nous directement. Notre équipe administrative vérifiera votre couverture et vous guidera pour une prise en charge optimale.
            </p>
            <a
              href="tel:+2250000000000"
              className="inline-block px-8 py-3 rounded-lg font-bold text-sm transition-all"
              style={{ backgroundColor: '#fbaf45', color: '#1d3c5e' }}
            >
              <i className="fas fa-phone mr-2"></i> Nous Contacter
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
